import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Row,
  Col,
  Space,
  Button,
  Table,
  Menu,
  message,
  Input,
  Dropdown,
  DatePicker,
  ConfigProvider,
  Form,
  Select,
} from "antd";
import {
  getAllUsers,
  getAllGroups,
  getAllUsersOffice,
  banWalletQRCode,
  eraseWalletQRCode
} from "../../actions/users";
import {
  addImportErrors,
  emptyImportErrors,
  modifyActivationTime,
} from "../../actions/proximitycard";
import {
  FilterOutlined,
  CheckOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import axios from "axios";
import { withTranslation } from "react-i18next";
import moment from "moment";
import "jspdf-autotable";
import localehu from "antd/es/locale/hu_HU";
import {
  getAllAddresses,
  getAllCompaniesByOfficeId,
} from "../../actions/company";
import { userRoles } from "../../constants/roles-types";

const mapDispatchToProps = (dispatch) => {
  return {
    getAllUsers: (groupId, companyId, activeOnly, walletCodeNotNull) =>
      dispatch(getAllUsers(groupId, companyId, activeOnly, walletCodeNotNull)),
    getAllGroups: () => dispatch(getAllGroups()),
    emptyImportErrors: () => dispatch(emptyImportErrors()),
    addImportErrors: (errors) => dispatch(addImportErrors(errors)),
    banWalletQRCode: (cardId) => dispatch(banWalletQRCode(cardId)),
    eraseWalletQRCode: (cardId) => dispatch(eraseWalletQRCode(cardId)),
    modifyActivationTime: (params) => dispatch(modifyActivationTime(params)),
    getAllAddresses: (companyId, officeId) =>
      dispatch(getAllAddresses(companyId, officeId)),
    getAllCompaniesByOfficeId: (officeId) =>
      dispatch(getAllCompaniesByOfficeId(officeId)),
    getAllUsersOffice: (companyId, activeOnly, walletCodeNotNull) =>
      dispatch(getAllUsersOffice(companyId, activeOnly, walletCodeNotNull)),
  };
};

class QRWalletCodes extends Component {
  state = {
    email: "",
    rfidString: "",
    searchedColumn: "activationTime",
    searchText: new Date().toLocaleDateString(),
    qrCapability: true,
    loaded: false,
    activated: false,
    modifyVisible: false,
    newWorkerVisible: false,
    activationTime: moment(),
    file: [],
    users: [],
    badEmail: [],
    emptyRFID: [],
    emptyEmail: [],
    duplicatedRFID: [],
    filteredInfo: {},
    selectedId: null,
    companies: [],
    selectedFilterCompanyId: null,
    selectedCompanyId: null,
    addNewCardVisible: false,
    selectedUserId: null,
    qrCodeActivationTime: null
  };

  formRef = React.createRef();
  componentDidMount = async () => {
    await this.props.getAllGroups();
    await this.getUsers();
    if (this.props.user.companyId && this.props.companyId) {
      await this.props.getAllAddresses(
        this.props.companyId || this.props.user.companyId
      );
    } else {
      await this.props.getAllAddresses(undefined, this.props.user.officeId);
      await this.props.getAllCompaniesByOfficeId(this.props.user.officeId);
    }
    this.setState({ loaded: true });
  };

  getUsers = async () => {
    this.setState({ loaded: false });
    if (this.props.user.officeId) {
      await this.props.getAllUsersOffice(null, null, true);
    } else {
      await this.props.getAllUsers([2, 3, 4, 5], this.props.user.companyId, true, true);
    }
    if (this.props.usersStatus) {
      this.setState({ users: this.props.users });
    }
    this.setState({ loaded: true });
  };

  handleChangeTable = (pagination, filters, sorter) => {
    this.setState({
      filteredInfo: filters,
      sortedInfo: sorter,
    });
  };

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  banQRWalletCode = async (userId) => {
    this.setState({ activated: false });
    await this.props.banWalletQRCode(userId);
    this.getUsers();
  };

  activateQRWalletCode = async (record) => {
    this.setState({ activated: true, modifyVisible: false });
    await this.props.banWalletQRCode(record);
    this.getUsers();
  };

  eraseWalletQRCODE = async (record) => {
    this.setState({ activated: false });
    await this.props.eraseWalletQRCode(record);
    this.getUsers();
  };

  hasRight = (rights, notAllowedSubscriptions) => {
    let allowed = false;
    this.props.user.groups.forEach((group) => {
      if (rights.includes(group.id)) {
        allowed = true;
      }
    });
    if (allowed === true && notAllowedSubscriptions === undefined) {
      return true;
    } else {
      if (allowed === true) {
        if (this.allowedBySubscription(notAllowedSubscriptions)) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }
  };

  allowedBySubscription = (notAllowedSubscriptions) => {
    if (this.props.user.companyId === null) {
      return false;
    } else {
      if (
        notAllowedSubscriptions !== undefined &&
        notAllowedSubscriptions !== null
      ) {
        if (
          notAllowedSubscriptions.includes(
            this.props.user.company.subscriptionId
          )
        ) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    }
  };

  handleFilterQRCapability = () => {
    const filteredUsers = this.props.users.filter(
      (user) => user.qrCapability === true
    );
    this.setState({ users: filteredUsers, filterKey: "acqrCapabilitytive" });
  };

  handleResetFilter = async () => {
    this.getUsers();
    this.resetFilter();
  };

  resetFilter = () => {
    this.setState({
      filteredInfo: {},
      filterKey: null,
      selectedFilterCompanyId: null,
    });
  };

  handleFilterCompanySelect = async (companyId) => {
    this.setState({
      selectedFilterCompanyId: companyId,
    });
    await this.props.getAllUsers([2, 3, 4, 5], companyId, true, true);
    this.setState({ users: this.props.users });
  };

  handleCompanySelect = async (event) => {
    this.setState({
      selectedCompanyId: event,
    });
  };

  handleUserSelect = async (event) => {
    this.setState({
      selectedUserId: event,
    });
  };

  renderFilterMenu = () => {
    return (
      <Menu activeKey={this.state.filterKey}>
        <Menu.Item onClick={this.handleFilterQRCapability} key="active">
          {this.props.t("active-filter-card-button-label")}
        </Menu.Item>
        <Menu.Item onClick={this.handleFilterInactive} key="inactive">
          {this.props.t("inactive-filter-card-button-label")}
        </Menu.Item>
      </Menu>
    );
  };

  handleFilterInactive = () => {
    const filteredUsers = this.props.users.filter(
      (card) => card.qrCapability === false
    );
    this.setState({ users: filteredUsers, filterKey: "inactive" });
  };

  onDateChange = async (value) => {
    this.setState({ qrCodeActivationTime: value });
  };

  onOk = async (record) => {
    const params = { id: record.id, qrCodeActivationTime: this.state.qrCodeActivationTime };
    await this.props.modifyActivationTime(params);
    this.getUsers();
    this.setState({ modifyVisible: false, selectedId: null });
  };

  onModifyVisible = async (id) => {
    this.setState({ modifyVisible: true, selectedId: id });
  };

  getColumnSearchProps = (dataIndex, searchLabel, type = "text") => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => {
      let date = selectedKeys[0];
      if (selectedKeys[0] === undefined || selectedKeys[0] === null) {
        date = new Date();
      }
      return (
        <div style={{ padding: 8 }}>
          {dataIndex === "qrCodeActivationTime" ? (
            <div>
              <ConfigProvider locale={localehu} name="qrCodeActivationTime">
                <DatePicker
                  ref={(node) => {
                    this.searchInput = node;
                  }}
                  placeholder={`${searchLabel}`}
                  value={moment(date, "YYYY-MM-DD")}
                  format={["YYYY-MM-DD", "DD-MM-YYYY"]}
                  locale={{ dateTimeFormat: "YYYY-MM-DD" }}
                  onChange={(e, text) => {
                    setSelectedKeys(
                      text ? [new Date(text).toLocaleDateString()] : []
                    );
                  }}
                  onPressEnter={() =>
                    this.handleSearch(selectedKeys, confirm, dataIndex)
                  }
                  style={{ width: 188, marginBottom: 8, display: "block" }}
                />
              </ConfigProvider>
            </div>
          ) : (
            <div>
              <Input
                ref={(node) => {
                  this.searchInput = node;
                }}
                placeholder={`${searchLabel}`}
                value={selectedKeys[0]}
                onChange={(e) =>
                  setSelectedKeys(e.target.value ? [e.target.value] : [])
                }
                onPressEnter={() =>
                  this.handleSearch(selectedKeys, confirm, dataIndex)
                }
                style={{ width: 188, marginBottom: 8, display: "block" }}
              />
            </div>
          )}

          <Space>
            <Button
              type="primary"
              onClick={() =>
                this.handleSearch(selectedKeys, confirm, dataIndex)
              }
              icon={<SearchOutlined />}
              size="small"
              style={{ width: 90 }}
            >
              {this.props.t("search-button-label")}
            </Button>
            <Button
              onClick={() => this.handleReset(clearFilters)}
              size="small"
              style={{ width: 100 }}
            >
              {this.props.t("reset-button-label")}
            </Button>
          </Space>
        </div>
      );
    },
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) => {
      if (type === "text") {
        return record[dataIndex]
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase());
      } else {
        return new Date(record[dataIndex])
          .toLocaleString()
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase());
      }
    },
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput?.select?.());
      }
    },
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: "" });
  };

  excelExport = async () => {
    let url = `/2.0.0/users/export-qr-wallet-codes`;

    const exportDate = new Date().toLocaleDateString().replace(" ", "").replace(".","_").replace(" ", "").replace(".","_").replace(" ", "").replace(".","");
    await axios.get(url, { responseType: "blob" })
      .then((response) => {
        const url = URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `qr_wallet_export_${exportDate}.xlsx`
        );
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      })
      .catch((err) => {
        message.error(this.props.t("empty-text"));
        console.log(err);
      });
  };

  render() {
    moment.updateLocale("en", {
      week: {
        dow: 8,
      },
      weekdaysMin: [
        this.props.t("Sun"),
        this.props.t("Mon"),
        this.props.t("Tue"),
        this.props.t("Wed"),
        this.props.t("Thu"),
        this.props.t("Fri"),
        this.props.t("Sat"),
      ],
      monthsShort: [
        this.props.t("Jan"),
        this.props.t("Feb"),
        this.props.t("Mar"),
        this.props.t("Apr"),
        this.props.t("May"),
        this.props.t("Jun"),
        this.props.t("Jul"),
        this.props.t("Aug"),
        this.props.t("Sep"),
        this.props.t("Oct"),
        this.props.t("Nov"),
        this.props.t("Dec"),
      ],
    });

    const columns = [
      {
        title: this.props.t("companyadmin-regapp-table-header-token"),
        key: "code",
        dataIndex: "code",
        sorter: (a, b) => a.code.localeCompare(b.code),
        sortDirections: ["ascend", "descend"],
        ...this.getColumnSearchProps(
          "code",
          this.props.t("rfidString-label")
        ),
      },
      {
        title: this.props.t("proximity-card-owner"),
        key: "email",
        dataIndex: "email",
        sorter: (a, b) => a.email.localeCompare(b.email),
        sortDirections: ["ascend", "descend"],
        ...this.getColumnSearchProps("email", this.props.t("email-label")),
      },
      {
        title: this.props.t("companyadmin-regapp-table-header-inuse"),
        key: "qrCapability",
        sorter: (a, b) => Number(a.qrCapability) - Number(b.qrCapability),
        sortDirections: ["ascend", "descend"],
        render: (text, record) => (
          <Space
            size="middle"
            style={{ display: "flex", alignItems: "center" }}
          >
            <div
              style={{
                width: "1.1vw",
                height: "1.1vw",
                borderRadius: "50%",
                backgroundColor: record.qrCapability ? "green" : "gray",
              }}
            />
          </Space>
        ),
      },
      {
        title: this.props.t("automatic-activitation-time"),
        key: "qrCodeActivationTime",
        sorter: (a, b) => {
          const qrCodeActivationTimeA = a.qrCodeActivationTime || "";
          const qrCodeActivationTimeB = b.qrCodeActivationTime || "";

          return qrCodeActivationTimeA.localeCompare(qrCodeActivationTimeB);
        },
        sortDirections: ["ascend", "descend"],
        render: (text, record) =>
          record.qrCapability === false &&
          this.state.modifyVisible === true &&
          this.state.selectedId === record.id ? (
            <Space>
              <DatePicker
                value={this.state.qrCodeActivationTime}
                defaultValue={record.qrCodeActivationTime}
                format={["YYYY-MM-DD"]}
                disabled={record.qrCapability === true}
                locale={{ dateTimeFormat: "YYYY-MM-DD" }}
                showToday={false}
                placeholder={
                  record.qrCapability && record.qrCodeActivationTime
                    ? moment(record.qrCodeActivationTime).format("YYYY-MM-DD")
                    : moment()
                }
                onChange={this.onDateChange}
              />
              <Button
                onClick={() => this.onOk(record)}
                disabled={record.qrCapability === true}
              >
                <CheckOutlined />
              </Button>
            </Space>
          ) : (
            <>
              {record.qrCodeActivationTime
                ? moment(record.qrCodeActivationTime).format("YYYY-MM-DD")
                : this.props.t("empty-text")}
            </>
          ),
        ...this.getColumnSearchProps(
          "qrCodeActivationTime",
          this.props.t("automatic-activitation-time"),
          "date"
        ),
      },
      {
        title: this.props.t(""),
        key: "actions",
        render: (text, record) => (
          <Space size="middle">
            <Button
              disabled={!record.qrCapability}
              onClick={() => this.banQRWalletCode(record.id)}
              danger
            >
              {this.props.t("companyadmin-regapp-table-header-ban")}
            </Button>

            <Button
              disabled={record.qrCapability}
              onClick={() => this.activateQRWalletCode(record.id)}
            >
              {this.props.t("companyadmin-languages-table-header-activate")}
            </Button>
          </Space>
        ),
      },
      {
        title: this.props.t(""),
        key: "update",
        render: (text, record) => (
          <Space size="middle">
            <Button
              visible={this.hasRight([
                userRoles.SYSTEM_ADMIN,
                userRoles.COMPANY_ADMIN,
                userRoles.HR_ADMIN,
                userRoles.OFFICE_ADMIN
              ])}
              disabled={record.qrCapability}
              onClick={() => this.eraseWalletQRCODE(record.id)}
              danger
              type="primary"
            >
              {this.props.t("entrypoints-delete-button-label")}
            </Button>
          </Space>
        ),
      },
    ];

    return (
      <div>
        <Row>
          <Col span={20}>
            <h1 style={{ fontSize: "2rem", color: "#00A49A" }}>
              <strong>
                {this.props.t("companyadmin-tabstitle-qr-wallet")}
              </strong>
            </h1>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <div style={{ float: "right", padding: "1em" }}>
                {this.hasRight([userRoles.OFFICE_ADMIN]) && (
                  <>
                    <Form.Item
                      name="comapanyId"
                      label={this.props.t("companies-title")}
                      rules={[]}
                    >
                      <Select
                        style={{ width: "15em" }}
                        onChange={(event) =>
                          this.handleFilterCompanySelect(event)
                        }
                        value={this.state.selectedFilterCompanyId}
                      >
                        {this.props.companies.map((company) => {
                          return (
                            <Select.Option key={company.id} value={company.id}>
                              {company.name}
                            </Select.Option>
                          );
                        })}
                      </Select>
                    </Form.Item>
                  </>
                )}
                <Dropdown
                  overlay={this.renderFilterMenu}
                  placement="bottomLeft"
                >
                  <Button icon={<FilterOutlined />} style={{ margin: "1em" }}>
                    {this.props.t("filters-button-label")}
                  </Button>
                </Dropdown>
                <Button
                  style={{ margin: "1em" }}
                  onClick={this.handleResetFilter}
                  disabled={
                    this.state.filterKey === null &&
                    Object.keys(this.state.filteredInfo).length === 0
                  }
                >
                  {this.props.t("reception-guests-resetfilters-button-label")}
                </Button>
              </div>
            </div>
          </Col>
          <Col span={4}>
            <Button type="primary" onClick={this.excelExport}>
              Export
            </Button>
          </Col>
        </Row>

        <Row>
          <Col span={24}>
            <Table
              columns={columns}
              rowKey="id"
              dataSource={this.state.users}
              locale={{ emptyText: this.props.t("empty-text") }}
              loading={!this.state.loaded}
              pagination={{
                position: ["bottomCenter"],
                showSizeChanger: true,
              }}
              onChange={this.handleChangeTable}
            />
          </Col>
        </Row>
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  user: state.loginReducer.user,
  token: state.loginReducer.token,
  users: state.usersReducer.users,
  groups: state.usersReducer.groups,
  usersStatus: state.usersReducer.status,
  saveStatus: state.usersReducer.saveStatus,
  message: state.usersReducer.message,
  staus: state.usersReducer.status,
  addresses: state.companyReducer.addresses,
  companies: state.companyReducer.companies,
});
const UserQRWalletCodes = withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(QRWalletCodes)
);
export default UserQRWalletCodes;
